import { withAuthToken } from './fileUtils';
import { getAccessToken } from '../services/authStorage';

// Client-side caps mirroring the server's MAX_ZIP_FILES / MAX_ZIP_BYTES defaults
// (#686). Above either, the UI points the user at Push Externally instead of a zip
// link — a bare <a download> can't surface the server's 413 (it would save the JSON
// as a .zip). The page overrides these with the server's effective `zip_limits`.
export const ZIP_MAX_FILES = 500;
export const ZIP_MAX_BYTES = 20 * 1024 * 1024 * 1024;

/**
 * Token-bearing URL for the streaming ZIP download endpoint (#686), or null when
 * unauthenticated / no observation — so callers suppress the link rather than
 * emit `?token=null`, which 401s and saves the JSON error under a .zip name.
 */
export function zipDownloadUrl(obsId, format = 'raw') {
  if (!obsId || !getAccessToken()) return null;
  return withAuthToken(`/api/v1/observations/${obsId}/download.zip?format=${format}`);
}
